import type { MenuScreen } from '../types.js';
import { createScreenShell, createMenuHeader, createCrestButton, el } from '@bn-games/ui-shell';
import { t } from '../../i18n/I18n.js';

const PARAGRAPH_SEP = '\n\n';

export function createAboutScreen(): MenuScreen {
  let frame: HTMLElement | null = null;

  return {
    mount(root, ctx) {
      const shell = createScreenShell();
      frame = shell.frame;
      const body = shell.body;

      body.appendChild(createMenuHeader({ title: t('about.title') }));

      const list = el('div', {
        class: 'about',
        attrs: {
          role: 'region',
          'aria-label': t('about.title'),
          tabindex: '0',
        },
      });

      const paragraphs = t('about.body').split(PARAGRAPH_SEP);
      for (const p of paragraphs) {
        list.appendChild(el('p', { class: 'about-paragraph', text: p }));
      }

      body.appendChild(list);

      const back = el('div', { class: 'button-row back-button-row' }, [
        createCrestButton({
          label: t('common.back'),
          small: true,
          onClick: () => ctx.navigate('menu'),
        }),
      ]);
      body.appendChild(back);

      root.appendChild(frame);
    },
    unmount() {
      frame?.remove();
      frame = null;
    },
  };
}
